import { dateToUnix } from "./date-converter";
import differenceBy from "lodash/differenceBy";

export const createActivityLogPayload = (payload, model_type, message) => {
  return {
    unique_id: payload.unique_id,
    activity_details: { message },
    activity_type: "create",
    model_type,
    created_date: new Date(),
  };
};

export const createActivityLogStatusPayload = (
  payload,
  model_type,
  prev_status,
  curr_status
) => {
  return {
    unique_id: payload.unique_id,
    activity_details: { message: "เปลี่ยนสถานะ", prev_status, curr_status },
    activity_type: "status_change",
    created_date: new Date(new Date().getTime() + 100),
    model_type,
  };
};

export const createActivityLogCopiedPayload = (payload, model_type) => {
  return {
    unique_id: payload.unique_id,
    activity_details: {
      message: "คัดลอก",
    },
    activity_type: "copy",
    created_date: new Date(),
    model_type,
  };
};

export const createActivityLogEditPayload = (payload, model_type, message) => {
  return {
    unique_id: payload.unique_id,
    activity_details: {
      message: { message },
    },
    activity_type: "edit",
    created_date: new Date(),
    model_type,
  };
};

export const createActivityLogDeletePayload = (payload, model_type) => {
  return {
    unique_id: payload.unique_id,
    activity_details: {
      message: "ลบ",
    },
    activity_type: "delete",
    created_date: new Date(),
    model_type,
  };
};

export const findDifferenceEmployee = (payload, existing) => {
  const { employee_list: existingEmployeeList } = existing;
  const { employee_list: currentEmployeeList } = payload;

  if (existingEmployeeList) {
    const existingDocumentId = existingEmployeeList.map((exist) => ({
      unique_id: exist.unique_id,
      first_name: exist.first_name,
      last_name: exist.last_name,
    }));

    const currentDocumentId = currentEmployeeList.map((curr) => ({
      unique_id: curr.unique_id,
      first_name: curr.first_name,
      last_name: curr.last_name,
    }));

    const addedEmployeeList = differenceBy(
      currentDocumentId,
      existingDocumentId,
      "unique_id"
    );
    const deletedEmployeeList = differenceBy(
      existingDocumentId,
      currentDocumentId,
      "unique_id"
    );

    return {
      addedEmployeeList,
      deletedEmployeeList,
    };
  }
};

export const createActivityLogEmployeePayload = (
  payload,
  activity_type,
  employee_list,
  model_type
) => {
  if (employee_list) {
    return {
      unique_id: payload.unique_id,
      activity_details: activity_type.startsWith("add")
        ? {
            message: "เพิ่มผู้เกี่ยวข้อง",
            added_related_employee: employee_list,
          }
        : {
            message: "ลบผู้เกี่ยวข้อง",
            deleted_related_employee: employee_list,
          },
      activity_type,
      created_date: new Date(),
      model_type,
    };
  }
};

export const createActivityLogApprovePayload = (
  payload,
  message,
  model_type
) => {
  return {
    unique_id: payload.unique_id,
    activity_details: {
      message,
    },
    activity_type: "approve",
    created_date: new Date(),
    model_type,
  };
};
